

import http from '../utils/request.js'
const getProductList = ( data ) => {
    return http.post('/product', data)
}
const getCategoryList = (data) => {
    return http.post('/catalog', data)
}
const getProductDetail = (param) => {
    return http.post('/course', { 'action': 'detail', param })
}
export {
    getProductList,
    getCategoryList,
    getProductDetail
}